import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { atom } from 'jotai';
import { fetchSeriesVariationRates } from '../api/seriesVariationRate';

// Map<seriesID string, rates[]>
const seriesVariationRatesAtom = atom(new Map());
// Module-level set to deduplicate in-flight requests across all instances
const inFlight = new Set();

const useSeriesVariationRates = (seriesID) => {
    const [ratesMap, setRatesMap] = useAtom(seriesVariationRatesAtom);
    const key = String(seriesID);

    useEffect(() => {
        if (!seriesID || ratesMap.has(key) || inFlight.has(key)) return;

        inFlight.add(key);

        fetchSeriesVariationRates(seriesID)
            .then(data => {
                setRatesMap(prev => {
                    const next = new Map(prev);
                    next.set(key, data);
                    return next;
                });
            })
            .catch(() => {
                setRatesMap(prev => {
                    const next = new Map(prev);
                    next.set(key, []);
                    return next;
                });
            })
            .finally(() => {
                inFlight.delete(key);
            });
    }, [seriesID, key]); // eslint-disable-line

    return ratesMap.get(key) ?? null;
};

export default useSeriesVariationRates;
